<template>
  <el-dialog title="申请销毁" :visible.sync="dialogVisible" width="70%">
    <el-row class="custom-container">
      <el-col :span="4">
       <el-image
            v-if="infoData.imagesList !=null"
            style="width: 100%; height: 100%;"
            :src="infoData.imagesList[0]"
            :preview-src-list="infoData.imagesList"
        ></el-image>
        <div v-else>
            暂无图片
        </div>
      </el-col>
      <el-col :span="18" :offset="2">
        <div class="inform flex">
          <div class="title">库存编号：</div>
          <div>{{ infoData.inventoryNumber }}</div>
        </div>
        <div class="inform flex">
          <div class="title">公司：</div>
          <div>{{ infoData.branchCompanyName }}</div>
        </div>
        <div class="inform flex">
          <div class="title">全称：</div>
          <div>{{ infoData.productFullName }}</div>
        </div>
        <div class="inform flex">
          <div class="title">简称：</div>
          <div>{{ infoData.productSimpleName }}</div>
        </div>
        <div class="inform flex">
          <div class="title">描述：</div>
          <div>{{ infoData.productDescription }}</div>
        </div>
        <el-row type="flex" justify="space-between">
          <div class="inform flex">
            <div class="title">即时库存数量：</div>
            <div>{{infoData.actualCount}}</div>
          </div>
        </el-row>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <el-row type="flex" align="middle" style="margin-top: 20px;">
      <el-col :span="6">申请数量：全部</el-col>
      <el-col :span="6">仓库名称：{{ infoData.warehouseName }}</el-col>
      <el-col :span="6">货架：{{ infoData.shelfNumber }}</el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="confirmOutWarehouse" :loading="isDoneBtnLoding">确认销毁</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: "ApplicationForWarehouse",

  data() {
    return {
      dialogVisible: false,
      infoData: {},
      isDoneBtnLoding: false
    };
  },
  mounted() { },
  created() { },
  methods: {
    init(row) {
      this.infoData = row
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
      this.isDoneBtnLoding = false;
    },
    confirmOutWarehouse() {
        this.$confirm('是否确认销毁?', '销毁', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDoneBtnLoding = true;
          const paramsData = {
            id: this.infoData.id,
            operateType: this.infoData.operateType,
            inventoryId: this.infoData.inventoryId,
            inventoryBatchNo:this.infoData.inventoryBatchNo
          };
          this.$emit("confirm", paramsData);
        })
    }
  }
};
</script>
<style lang="scss" scoped>
.custom-container {
  padding: 0 20px;
  display: flex;
  align-items: center;
}
.inform {
  line-height: 30px;
  &.flex {
    display: flex;
    .title {
      flex-shrink: 0;
      font-weight: bold;
    }
  }
}
.channel-flex {
  display: flex;
  margin-right: 20px;
}
</style>